import { TFilterSelected } from '@monorepo/types';

export const ReportsV2EndPoints = {
  REPORT_LIST: '/v2/factory/reports/:factoryId',
  REPORT_VIEW: '/v2/reports/view',
  REPORT_DOWNLOAD: '/v2/reports/download',
  REPORT_FILTERS: '/v2/factory/report/filters/subjectKey/:factoryId/reportId/:reportId/durationType/:durationType',
};

type TDuration =
  | { display_name: 'Monthly'; duration_type: 'MONTHLY' }
  | { display_name: 'Daily'; duration_type: 'DAILY' }
  | { display_name: 'Hourly' | 'Cumulative'; duration_type: 'HOURLY' };

type TReportType = {
  report_id: string;
  display_name: string;
  duration: TDuration[];
};

export type TRESPONSE_REPORT_LISTING_V2 = {
  reports: TReportType[];
};

export type TReportFilterDate = {
  isMandatory: boolean;
  filterType: 'DURATION';
  filterOptions: {
    allowedDateRange?: {
      minDate: string;
      maxDate: string;
    };
    type: 'SINGLE_DATE' | 'DATE_RANGE' | 'MONTH_RANGE';
    allowedMaxWindow?: number;
  };
};

export type TReportFilter = {
  isMandatory: boolean;
  filterType: 'BCTX' | 'ORG_HEIRARCHY';
  allFilterSelectionMandatory?: boolean;
  supportedFilters: TFilterSelected[];
  selectedFilters: TFilterSelected[];
};

export type TRequestReportFilter = {
  filterType: 'BCTX' | 'ORG_HEIRARCHY';
  selectedFilters: TFilterSelected[];
};

export type TRESPONSE_REPORT_FILTERS = {
  name: string;
  reportId: string;
  filters: (TReportFilterDate | TReportFilter)[];
};

export type TRequestReportFilterDate = {
  filterType: 'DURATION';
  selectedDate?: [sDate?: string, endDate?: string];
  filterOptions?: {
    allowedDateRange?: {
      minDate: string;
      maxDate: string;
    };
    type: 'SINGLE_DATE' | 'DATE_RANGE' | 'MONTH_RANGE';
    allowedMaxWindow?: number;
  };
};

export type TREQUEST_REPORT_FILTERS = {
  reportId: string;
  filters: (TRequestReportFilter | TRequestReportFilterDate)[];
};

export type TREQUEST_REPORT_SUGGESTIONS = {
  reportId: string;
  key: string;
  searchString: string;
  filters: (TRequestReportFilter | TRequestReportFilterDate)[];
};

export type TRESPONSE_REPORT_SUGGESTIONS = {
  searchResultItems: string[];
};

export type TREQUEST_VIEW_REPORT = TREQUEST_REPORT_FILTERS;

export type TREQUEST_DOWNLOAD_REPORT_EXCEL = TREQUEST_VIEW_REPORT & {
  fileType: 'XLS';
};

/**
 * subtotal, subtotal_name, grandtotal, from to etc are optional and can only be of specified type as mentioned,
 *  while there can be any other prop with string | number.
 * below typing is divided because indexsignature cannot except literals as keys. and this helps narrowing types
 * for example subtotal cannot be string | number;
 **/

export type TCellValueReportsV2 =
  | string
  | number
  | boolean
  | { value?: string; color: 'RED' | 'GREEN' | 'YELLOW' | null }
  | { value: string; type: 'LINK' };

type TBackendValueType =
  | TCellValueReportsV2
  | { span: number; start_col: number; end_col: number }[]
  | { startCol: number; endCol: number; span: number };

type TBackendKeyValues = {
  [key: string]: TBackendValueType | undefined | null;
  subtotal?: true | null;
  subtotal_name?: string | null;
  grandtotal?: true | null;
  from?: number | null;
  to?: number | null;
  image_url?: { value: string; type: 'LINK' };
  row_merge?: boolean;
  special_row_merge?: boolean;
  merge_spec?: { span: number; start_col: number; end_col: number }[] | null;
  vertical_merge_spec?: { startCol: number; endCol: number; span: number } | null;
};

export type TRESPONSE_VIEW_REPORT = {
  data: TBackendKeyValues[];
  columnMetaData: { key: string; textAlignment?: 'VERTICAL' | 'HORIZONTAL'; displayName: string }[];
};
